import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

// Modal "Reporte de garantía Honda — Fase A": al agregar un servicio de reporte de
// garantía se pide el reporte del cliente (lo que motiva el reclamo). Funciona igual que
// DatosCuponDialog: si se cancela, el padre quita la tarea recién agregada.
export const GarantiaReporteClienteDialog = ({ open, onOpenChange, onGuardar, guardando = false }) => {
  const [reporteCliente, setReporteCliente] = useState("");

  useEffect(() => {
    if (open) setReporteCliente("");
  }, [open]);

  const valido = reporteCliente.trim().length > 0;

  const guardar = () => {
    if (!valido) return;
    onGuardar({ reporte_cliente: reporteCliente.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="garantia-reporte-cliente-dialog" className="bg-white max-w-lg">
        <DialogHeader>
          <DialogTitle>Reporte de garantía Honda</DialogTitle>
        </DialogHeader>
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-slate-700">Reporte del cliente</label>
          <Textarea data-testid="garantia-reporte-cliente-input" rows={4} value={reporteCliente}
            onChange={(e) => setReporteCliente(e.target.value)}
            placeholder="Ej.: Cliente reporta fuga de aceite" />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" data-testid="garantia-reporte-cliente-cancelar-btn"
            onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button data-testid="garantia-reporte-cliente-guardar-btn" onClick={guardar}
            disabled={!valido || guardando} className="bg-indigo-600 hover:bg-indigo-700 text-white">
            {guardando ? "Guardando..." : "Guardar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
